import { NgModule } from '@angular/core';
import { AppModuleConstants } from './app-module.constants';
import { AppComponent } from './app.component';
import { httpInterceptorProviders } from './interceptor';
import { AppConfigService } from './app-config.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { AppTranslateService } from './translations/services/app-translation.service';
import { TranslateLoader, MissingTranslationHandler, TranslateModule, TranslateService } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from './translations/services/app-missingTranslation.service';
import { CacheService } from './shared/services/cache.service';
import { CacheKey } from './shared/constants/cachekey.constants';
import { SharedConstants } from './shared/constants/shared.constants';
import { HttpClient } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient, localStorage: LocalStorageService) {
  return new AppTranslateService(http, localStorage);
}
const translationOptions = {
  loader: {
    provide: TranslateLoader,
    useFactory: (createTranslateLoader),
    deps: [HttpClient, LocalStorageService]
  },
  missingTranslationHandler: {
    provide: MissingTranslationHandler,
    useClass: MyMissingTranslationHandler
  }
};
@NgModule({
	imports: [...AppModuleConstants.MODULE_IMPORTS, 
    TranslateModule.forRoot(translationOptions)
  ],
	declarations: AppModuleConstants.MODULE_DECLARATIONS,
	bootstrap: [AppComponent],
	providers: [httpInterceptorProviders, AppConfigService]
})
export class AppModule {
	language: any;
  defaultlang: any;
  constructor(private translate: TranslateService, private localStorageService: LocalStorageService, private _cacheService: CacheService) {
    this.defaultlang = this.localStorageService.get('DefaultLanguage');
    this.language = this._cacheService.getCookieValue(CacheKey.languageCode);
    const eventPage = SharedConstants.EVENT_PAGES.find((page: string) => {
      return window.location.href.toLowerCase().indexOf(page.toLowerCase()) > -1;
    });
    if (!eventPage) {
      if (this.language) {
      this.translate.use(this.language);
      } else if (this.defaultlang) {
      this.translate.use(this.defaultlang);
      }
    } else{
      this.translate.use('en-US');
    }
  }
}
